import axios from "axios";
import { urlTutoriais } from "../../../../../../constants/endpoints";

export const getTutoriais = async(filter = null) => {
  const response =await axios.get(urlTutoriais, { params: filter }) ;
  return response;
};

export const createTutorial = async (tutorial) => {
  if (!tutorial) throw new Error('dados do tutorial não informados');
  const response = await axios.post(urlTutoriais, tutorial, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  console.log(response)
  return response;
};

export const updateTutorial = async (id, tutorial) => {
  if (!id) throw new Error('id não informado');
  console.log("id:", id)
  console.log("tutorial: ",tutorial)
  const response = await axios.patch(`${urlTutoriais}/${id}`, tutorial);
  console.log(response)
  return response;
};

export const deletaTutorial = (id) => {
  if (!id) return Promise.reject('id não informado');
  return axios.delete(`${urlTutoriais}/${id}`)
}

export const downloadTutorial = async (id) => {
  if (!id) return Promise.reject('id não informado');
  try {
    const response = await axios.get(`${urlTutoriais}/${id}/download`, { 
      responseType: 'blob' 
    });
    const blob = new Blob([response.data], { type: response.headers['content-type'] });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `tutorial-${Date.now()}.pdf`);
  
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Erro ao baixar o tutorial:", error);
  }
};
